var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceMouthopenFilled = function SvgFaceMouthopenFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.875c-5.445 0-9.875-4.43-9.875-9.875S6.555 2.125 12 2.125s9.875 4.43 9.875 9.875-4.43 9.875-9.875 9.875ZM9.427 7.64c-.423 0-.766.524-.766 1.17 0 .646.343 1.17.766 1.17.422 0 .765-.524.765-1.17 0-.646-.343-1.17-.765-1.17Zm4.372 1.17c0-.646.343-1.17.765-1.17s.765.524.765 1.17c0 .646-.343 1.17-.765 1.17s-.765-.524-.765-1.17ZM12 16.86c-2.303 0-4.177-1.845-4.177-4.112a.5.5 0 0 1 .5-.5h7.354a.5.5 0 0 1 .5.5c0 2.267-1.874 4.112-4.177 4.112Zm0-1c-1.578 0-2.891-1.133-3.136-2.612h6.272C14.89 14.727 13.578 15.86 12 15.86Z",
    fill: "#000"
  })));
};
export default SvgFaceMouthopenFilled;